<!--Header-->
<app-navbar xmlns="http://www.w3.org/1999/html">
    <h2>404</h2>
</app-navbar>
<section class="error-area">
    <div class="error-item">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="error-text">
                    <h1>404!</h1>
                    <p>Ne cerem scuze! Pagina nu a fost găsită!</p>
                    <span>Ooops! Pagina pe care încercați să o accesați nu există. A fost mutată sau ștearsă.</span>
                    <a routerLink="" class="green-button">
                       Întoarce-te la pagina Principală
                       </a>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Footer-->
<app-footer></app-footer>
